/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useMemo, useRef, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useSearchParams } from 'react-router-dom';
import _ from 'lodash';
import { store } from 'redux/store';

import AppBar from '@components/app-bar';
import TasksList from './tasks-records-list';
import useWindowDimensions from '@hooks/useWindowDimensions';
import { getTemplates, transformTaskRecords } from './helper';

import { initWebWorker } from 'webworker';

import CheckSelector from 'selectors/checks/check.selector';
import { cacheActions } from '@redux/slices/cache';
import { getAppDispatch } from '@utilities/dispatch.util';
import { getLatestCoordinates } from '@utilities/get-distance';
import { checkIfTheLocationIsNeedToUpdateOrNot } from '@utilities/date-filters';

const Tasks = () => {
  const dataFetchedRef = useRef(false);
  let _store = { ...store.getState() };
  const location = useLocation();
  const { width } = useWindowDimensions();
  const dispatch = getAppDispatch();
  const { coordinates, unit, locationUpdateTime, syncedNewAndEditedEquipments, equipments } =
    useSelector((state) => state.cache);
  const [searchParams] = useSearchParams();

  const refetchSitesLocation = searchParams.get('RefetchSitesLocation');

  const {
    type = null,
    runs: runString = null,
    templates: templateString = null
  } = Object.fromEntries(new URLSearchParams(location.search));
  const { selectTask = false, tasksList: reduxTasksList = [] } = useSelector(
    (state) => state.tasks
  );
  const picklistsMap = useSelector((state) => state.picklists.picklistsMap) || {};

  const { utFormDownloadingLoading } = useSelector((state) => state.utFormData) || {};

  const { HSEEventList } = useSelector((state) => state.hseEvents);
  const { inspectionsList } = useSelector((state) => state.inspection);
  const { checksList } = useSelector((state) => state.checks);
  const parentRef = useRef(null);

  const [loading, setLoading] = useState(true);
  const [tasksList, setTasksList] = useState([]);
  const [templateTasksLists, setTemplateTasksLists] = useState([]);

  useEffect(() => {
    return () => {
      setLoading(true);
      setTasksList([]);
      setTemplateTasksLists([]);
    };
  }, []);

  const runs = useMemo(() => runString?.split(',').filter((el) => el), [runString]);
  const templates = useMemo(() => templateString?.split(',').filter((el) => el), [templateString]);

  useEffect(() => {
    if (utFormDownloadingLoading) {
      return;
    }
    checkIfTheLocationIsNeedToUpdateOrNot({
      addNewCoordinates: locationUpdateTime ? false : true,
      loadingFunctionCall: () => {},
      isOnline: navigator.onLine,
      unit,
      locationUpdateTime,
      oldCoordinates: coordinates,
      functionCall: getAllTasksListingFromSelector,
      params: {
        coordinates
      }
    });
  }, [
    // _store,
    reduxTasksList,
    inspectionsList,
    runs,
    templates,
    location?.pathname,
    templateString,
    HSEEventList,
    checksList,
    dispatch,
    unit,
    syncedNewAndEditedEquipments,
    equipments,
    // navigator.onLine,
    locationUpdateTime,
    coordinates,
    utFormDownloadingLoading
  ]);

  const getAllTasksListingFromSelector = ({ coordinates }) => {
    setLoading(true);
    initWebWorker({
      args: { store: { ..._store } },
      type: 'get-all-tasks-records'
    })
      .then((data) => {
        if ((runs?.length && runString) || (templates?.length && templateString)) {
          let templateTasks = getTemplates({
            type: type ? type : 'Work Order',
            tasks: data?.result,
            runs,
            templates
          });
          setTemplateTasksLists(templateTasks);
          const all = templateTasks?.map((x) => x?.tasks);
          const list = transformTaskRecords({ result: _.flattenDeep(all) || [], picklistsMap });
          setTasksList(list);
          setLoading(false);
        } else {
          // let arr = data?.result?.filter(
          //   (x) => x?.status === 'Pending sync' || x?.status === 'In progress'
          // );
          // console.log({ arr });

          const list = transformTaskRecords({ result: data?.result || [], picklistsMap });
          // console.log({ list: list?.filter((x) => x?.hasUTData) });
          // console.log({ list: list?.filter((x) => x?.workOrderNumber === 'RWO2656') });
          // ?.filter((x) => x?.workOrderNumber === 'RWO14192')
          setTasksList(list);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const moveTaskRecordPageToTop = useCallback(() => {
    parentRef?.current?.moveToTopOnClickTaskIcon();
  }, [parentRef]);

  return (
    <div className="page-container">
      {(!selectTask || width > 767) && <AppBar moveTaskRecordPageToTop={moveTaskRecordPageToTop} />}
      <div className="md:ml-24">
        <TasksList
          loading={loading}
          tasksList={tasksList}
          ref={parentRef}
          runs={runs}
          templates={templates}
          templateTasksLists={templateTasksLists}
        />
      </div>
    </div>
  );
};

export default Tasks;
